import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

export default function Footer() {
  const mainPages = [
    { name: 'Home', link: '/', type: 'page' },
    { name: 'About', link: '/#mission', type: 'anchor' },
    { name: 'Services', link: '/services', type: 'page' },
    { name: 'Contact', link: '/contact', type: 'page' }
  ]
  
  const featuredServices = [
    { name: 'Cloud Computing', link: '/services/cloud-computing' },
    { name: 'Professional Website Development', link: '/services/professional-website' },
    { name: 'Mobile & Web App Development', link: '/services/mobile-web-apps' },
    { name: 'Data Analysis & Business Insights', link: '/services/data-analysis' }
  ]
  
  const companyLinks = [
    { name: 'Our Mission', link: '/#mission' },
    { name: 'Our Vision', link: '/#mission' },
    { name: 'Core Values', link: '/#mission' },
    { name: 'Divisions', link: '/#divisions' },
    { name: 'Careers', link: '/careers' }
  ]
  
  return (
    <div className='bg-gradient-to-br from-gray-900 via-green-900 to-emerald-900 text-white relative overflow-hidden'>
      {/* Background decorative elements */}
      <div className='absolute inset-0'>
        <div className='absolute top-20 left-20 w-64 h-64 bg-green-600 rounded-full mix-blend-multiply filter blur-xl opacity-10'></div>
        <div className='absolute bottom-20 right-20 w-72 h-72 bg-emerald-600 rounded-full mix-blend-multiply filter blur-xl opacity-10'></div>
      </div>
      
      <div className='relative z-10 container mx-auto px-6 py-16'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12'>
          {/* Company Info */}
          <div className='lg:col-span-2'>
            <div className='flex items-center space-x-2 mb-6'>
              <h2 className='text-2xl font-bold font-comfortaa'>
                Arieri's <span className='text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500'>World Limited</span>
              </h2>
            </div>
            
            <p className='text-gray-300 mb-6 font-poppins leading-relaxed'>
              Transforming ideas into innovative digital solutions. We empower businesses with cutting-edge technology services that drive growth and success in the digital age.
            </p>
            
            <div className='space-y-3'>
              <div className='flex items-center space-x-3'>
                <PhoneIcon className='text-green-400' />
                <a href='tel:+254742073092' className='text-gray-300 hover:text-green-400 transition-colors duration-300'>
                  +254 742 073092
                </a>
              </div>
              <div className='flex items-center space-x-3'>
                <EmailIcon className='text-green-400' />
                <div className='flex flex-col'>
                  <a href='mailto:business@arierisworld.com' className='text-gray-300 hover:text-green-400 transition-colors duration-300'>
                    business@arierisworld.com
                  </a>
                </div>
              </div>
              <div className='flex items-center space-x-3'>
                <LocationOnIcon className='text-green-400' />
                <span className='text-gray-300'>Nairobi, Kenya</span>
              </div>
            </div>
          </div>
          
          {/* Navigation Links */}
          <div>
            <h3 className='text-lg font-semibold font-poppins mb-6 text-green-400'>Navigation</h3>
            <ul className='space-y-3'>
              {mainPages.map((item, index) => (
                <li key={index}>
                  <a 
                    href={item.link}
                    className='text-gray-300 hover:text-green-400 transition-colors duration-300 font-poppins flex items-center gap-2 group'
                  >
                    <span className='group-hover:translate-x-1 transition-transform duration-300'>{item.name}</span>
                    {item.type === 'page' && (
                      <svg className="w-3 h-3 opacity-50 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    )}
                  </a>
                </li>
              ))}
            </ul>
            
            <div className='mt-6'>
              <h4 className='text-md font-medium font-poppins mb-3 text-emerald-400'>Company</h4>
              <ul className='space-y-2'>
                {companyLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.link}
                      className='text-gray-400 hover:text-green-400 transition-colors duration-300 font-poppins text-sm hover:translate-x-1 transform inline-block'
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          {/* Featured Services */}
          <div>
            <h3 className='text-lg font-semibold font-poppins mb-6 text-green-400'>Featured Services</h3>
            <ul className='space-y-4'>
              {featuredServices.map((service, index) => (
                <li key={index}>
                  <a 
                    href={service.link}
                    className='text-gray-300 hover:text-green-400 transition-all duration-300 font-poppins text-sm flex items-center gap-3 group p-2 rounded-lg hover:bg-white/5'
                  >
                    <div className='w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-emerald-500 group-hover:scale-125 transition-transform duration-300'></div>
                    <span className='group-hover:translate-x-1 transition-transform duration-300 leading-tight'>{service.name}</span>
                    <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </li>
              ))}
            </ul>
            
            <div className='mt-6 pt-4 border-t border-white/10'>
              <a 
                href='/services'
                className='inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 transition-colors duration-300 font-poppins text-sm font-medium group'
              >
                <span>View All Services</span>
                <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        {/* Newsletter Section */}
        <div className='bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-12'>
          <div className='text-center mb-6'>
            <h3 className='text-2xl font-bold font-comfortaa mb-2'>Stay Connected</h3>
            <p className='text-gray-300 font-poppins'>
              Subscribe to our newsletter for the latest updates, exclusive deals, and tech insights.
            </p>
          </div>
          
          <div className='flex flex-col sm:flex-row gap-4 max-w-md mx-auto'>
            <input 
              type='email'
              className='flex-1 px-4 py-3 bg-white/20 border border-white/30 rounded-full text-white placeholder-gray-300 outline-none focus:border-green-400 transition-colors duration-300 font-poppins'
              placeholder='Enter your email'
            />
            <button className='bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 font-poppins'>
              Subscribe
            </button>
          </div>
        </div>
        
        {/* Social Media & Copyright */}
        <div className='border-t border-white/20 pt-8'>
          <div className='flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
            <div className='flex space-x-6'>
              <a 
                href='https://www.linkedin.com/company/arieri-s-world/' 
                target='_blank' 
                rel="noopener noreferrer"
                className='w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-blue-600 transition-all duration-300 transform hover:scale-110'
              >
                <LinkedInIcon style={{ color: 'white', fontSize: '20px' }} />
              </a>
              <a 
                href='https://www.instagram.com/arierisworld/?utm_source=qr&igsh=MTM5ZzVlc2dndGwyag%3D%3D#' 
                target='_blank' 
                rel="noopener noreferrer"
                className='w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-pink-600 transition-all duration-300 transform hover:scale-110'
              >
                <InstagramIcon style={{ color: 'white', fontSize: '20px' }} />
              </a>
              <a 
                href='https://web.facebook.com/profile.php?id=61578124533449' 
                target='_blank' 
                rel="noopener noreferrer"
                className='w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-blue-700 transition-all duration-300 transform hover:scale-110'
              >
                <FacebookIcon style={{ color: 'white', fontSize: '20px' }} />
              </a>
              <a 
                href='https://x.com/arierisworld?t=eqt3sFkqyC6HQ3vlmtNFeQ&s=09' 
                target='_blank' 
                rel="noopener noreferrer"
                className='w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-gray-800 transition-all duration-300 transform hover:scale-110'
              >
                <XIcon style={{ color: 'white', fontSize: '20px' }} />
              </a>
            </div>
            
            <div className='text-center md:text-right'>
              <p className='text-gray-300 font-poppins text-sm'>
                &copy; {new Date().getFullYear()} Arieri's World Limited. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
